<div
  [formGroup]="form"
  class="form -group"
  [class.is-invalid]="!isValid && (isDirty || isTouched)"
  [class.is-valid]="isValid && (isDirty || isTouched)">
  <span class="-fontMedium">
    {{ question.label }}
    @if (!question.required && !hideOptional) {
    <span> (Optional)</span>
    }
  </span>
  @if (question.help) {
  <span class="form -help">{{ question.help }}</span>
  } @switch (question.type) { @case ('radio') {
  <div class="form -group-wrapper">
    @for (option of question.options; track option) {
    <div class="form -group-element-wrapper noSelector">
      <label class="form -group-element noSelector">
        <input type="radio" [name]="question.key" [formControlName]="question.key" [value]="option.value" />
        <span class="form -group-element-radio"></span>
        <span class="form -group-element-label -fontSmall">{{ option.label }}</span>
      </label>
    </div>
    }
  </div>
  } @case ('checkbox') {
  <div [formGroupName]="question.key" class="form -group-wrapper">
    @for (option of question.options; track option) {
    <div class="form -group-element-wrapper noSelector">
      <label class="form -group-element noSelector">
        <input type="checkbox" [formControlName]="option.value" />
        <span class="form -group-element-checkbox"></span>
        @if (!hideCheckboxLabel) {
        <span class="form -group-element-label -fontSmall">{{ option.value }}</span>
        }
      </label>
    </div>
    }
  </div>
  } } @if (!isValid && (isDirty || isTouched)) {
  <span class="form -error -fontSmall">
    @if (errors.required) {
    <span> {{ question.label }} is required </span>
    } @if (errors.multiCheckboxRequired) {
    <span> {{ question.label }} is required </span>
    }
  </span>
  }
</div>
